import { ReactNode, useEffect, useState } from 'react';
import { CsvMappingApiModel, CsvMappingItemApiModel } from '~/lib/api/smartsend/types';
import { CsvUpload } from '../../csv/CsvUpload';
import { CsvSmartSendMapResult } from '../../csv/MapCsvDataToSmartSendItem';
import { MappingIsDefault } from '../../csv/MappingIsDefault';
import Loading from '../../../../../components/loading/Loading';
import { useSmartSendApi } from '~/lib/api/smartsend/use-smartsend-api';

interface props {
  onSave: (items: CsvSmartSendMapResult[], originalHeaders: string[]) => void;
  label?: ReactNode;
}

export const CsvCore: React.FC<props> = (props) => {
  const { createDefaultCsvMapping, getCsvMappings, updateCsvMapping } = useSmartSendApi();
  const [mappings, setMappings] = useState<CsvMappingApiModel[]>(null);

  useEffect(() => {
    const load = async () => {
      const list = await getCsvMappings();
      if (list.success) {
        if (list.result.CsvMappings.length === 0) {
          const d = await createDefaultCsvMapping();
          if (d.success) {
            list.result.CsvMappings.push(d.result.CsvMapping);
          }
        }
        setMappings(list.result.CsvMappings);
      } else {
        setMappings([]);
      }
    };
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const saveDefaultMapping = (selected: number, mappingsToSave: CsvMappingItemApiModel[]) => {
    if (mappingsToSave && mappingsToSave.length > 0) {
      const defaultMapping = mappings.find((x) => x.Id === selected) || mappings.find(MappingIsDefault);
      if (defaultMapping) {
        mappingsToSave
          .filter((x) => !!x.From && !!x.To)
          .forEach((n) => {
            defaultMapping.Mappings.push(n);
          });
        updateCsvMapping(defaultMapping);
      }
    }
  };

  return mappings ? (
    <CsvUpload onSave={props.onSave} mappings={mappings} saveDefaultMappings={saveDefaultMapping} label={props.label} />
  ) : (
    <Loading />
  );
};
